import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { STRAT_STATUS } from "./strategiUtils";

export default function NyStrategiModal({ onLagre, onLukk }) {
  const [form, setForm] = useState({ title: "", statement: "", status: "direction" });
  const [lagrer, setLagrer] = useState(false);
  useEffect(() => {
    const esc = (e) => { if (e.key === "Escape") onLukk(); };
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onLukk]);
  const sett = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const lagre = async () => {
    if (!form.title.trim() || lagrer) return;
    setLagrer(true);
    try { await onLagre(form); } finally { setLagrer(false); }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-[12vh] px-4" data-testid="ny-strategi-modal">
      <div className="sak-backdrop absolute inset-0 bg-black/25" onClick={onLukk} />
      <div className="sak-modal relative w-full max-w-[480px] bg-white rounded-2xl shadow-2xl border border-[#E7E4DB] p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-[15px] font-semibold">Nytt strategikort</h2>
          <button type="button" onClick={onLukk} className="text-neutral-400 hover:text-neutral-800 transition-colors" data-testid="ny-strategi-lukk">
            <X size={16} />
          </button>
        </div>
        <div className="grid gap-3">
          <label className="adm-label">
            Tittel *
            <input value={form.title} onChange={(e) => sett("title", e.target.value)} className="adm-input" data-testid="ny-strategi-tittel" autoFocus placeholder="F.eks. Ticket strategy" />
          </label>
          <label className="adm-label">
            Statement · 1–3 setninger
            <textarea rows={3} value={form.statement} onChange={(e) => sett("statement", e.target.value)} className="adm-input" data-testid="ny-strategi-statement" placeholder="Kort og presist — dette er kortets hovedtekst." />
          </label>
          <label className="adm-label">
            Status
            <select value={form.status} onChange={(e) => sett("status", e.target.value)} className="adm-input" data-testid="ny-strategi-status">
              {STRAT_STATUS.map((s) => (
                <option key={s.k} value={s.k}>{s.label}</option>
              ))}
            </select>
          </label>
        </div>
        <div className="flex items-center justify-end gap-2 mt-5">
          <button type="button" onClick={onLukk} className="adm-btn-ghost">Avbryt</button>
          <button type="button" onClick={lagre} disabled={!form.title.trim() || lagrer} className="adm-btn" data-testid="ny-strategi-lagre">
            {lagrer ? "Lagrer …" : "Legg til"}
          </button>
        </div>
      </div>
    </div>
  );
}
